import { render, staticRenderFns } from "./LoadingDonorPage.vue?vue&type=template&id=593e3ea1"
import script from "./LoadingDonorPage.vue?vue&type=script&lang=ts"
export * from "./LoadingDonorPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports